import { get, isNumber } from 'lodash';

/**
 * for a given price, extract all required discount parameters required for managing discounts
 * if any required fields are not present, return null
 * @param {*} price
 * @returns {{discountedPrice:number, price:number, discountPercent:number}|null}
 */
const getPriceDiscountValuesFromPrice = price => {
  const discountedPrice = get(price, ['discount', 'amount'], null);

  const amount = get(price, ['amount'], null);

  const discountPercent = get(price, ['discount', 'percent'], null);

  if (
    isNumber(discountedPrice) &&
    isNumber(amount) &&
    isNumber(discountPercent) &&
    discountPercent > 0 &&
    discountedPrice > 0
  ) {
    return { discountedPrice, price: amount, discountPercent };
  }

  return null;
};

/**
 * for a given inventory item, extract all required discount parameters required for managing discounts
 * if any required fields are not present, return null
 * @param {*} inventoryItem
 * @returns {{discountedPrice:number, price:number, discountPercent:number}|null}
 */
const getPriceDiscountValuesFromInventoryItem = inventoryItem => {
  const price = get(inventoryItem, ['price'], null);
  if (!price) return null;
  return getPriceDiscountValuesFromPrice(price);
};

export {
  getPriceDiscountValuesFromInventoryItem,
  getPriceDiscountValuesFromPrice
};
